import React from "react";
import CircularProgress from "@mui/material/CircularProgress";
import Paper from "@mui/material/Paper";
import ListItem from "@mui/material/ListItem";
import List from "@mui/material/List";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";

import { normalize } from "../../helpers/normalize";
import { Box } from "../../UI/Box";

interface IOption {
  id: number;
  name: string;
}

interface IProps {
  value?: string;
  label: string;
  fullWidth?: boolean;
  handleFocus?: VoidFunction;
  handleChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handleKeyDown?: React.KeyboardEventHandler<HTMLInputElement>;
  handleOptionSelect: (id: number) => VoidFunction;
  isLoading?: boolean;
  options: IOption[];
}

export const SearchInput: React.FC<IProps> = (props) => {
  const endAdornment = React.useMemo(
    () => (
      <>
        {props.isLoading && (
          <InputAdornment position="end">
            <CircularProgress size={24} />
          </InputAdornment>
        )}
      </>
    ),
    [props.isLoading]
  );

  const isNetworksShow = React.useMemo(() => !!props.options.length, [normalize(props.options)]);

  return (
    <Box position="relative">
      <TextField
        fullWidth={props.fullWidth}
        size="small"
        value={props.value}
        label={props.label}
        variant="filled"
        onFocus={props.handleFocus}
        onChange={props.handleChange}
        onKeyDown={props.handleKeyDown}
        sx={{
          minWidth: 280,
        }}
        placeholder="Type in at least 3 characters to search"
        InputProps={{
          endAdornment,
        }}
      />
      {isNetworksShow && (
        <Paper
          sx={{
            width: "100%",
            maxHeight: 300,
            overflowY: "auto",
            position: "absolute",
            zIndex: (theme) => theme.zIndex.modal + 1,
          }}
        >
          <List>
            {props.options.map((option) => (
              <ListItem button key={option.id} onClick={props.handleOptionSelect(option.id)}>
                {option.name} - {option.id}
              </ListItem>
            ))}
          </List>
        </Paper>
      )}
    </Box>
  );
};

SearchInput.defaultProps = {
  isLoading: false,
  fullWidth: false,
};
